module.exports = __webpack_public_path__ + "static/planbillingquora-ae252d1155b36a18889260e4f743507b.png";